"use client";

import React from "react";
import { ArrowRight, Utensils, Music } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NeighborhoodSpotlights() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const section1Reveal = useRevealOnScroll({
    threshold: 0.2
  });
  const section2Reveal = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="222911" id="neighborhood-spotlights" className="dark bg-background text-foreground py-20 px-4 md:px-8 lg:px-16 overflow-hidden">
      <div className="max-w-7xl mx-auto space-y-20">
        {}
        <div ref={headerReveal.ref} className={`text-center max-w-3xl mx-auto space-y-4 transition-all duration-1000 ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-5xl font-bold font-default tracking-tighter text-primary">
            Neighborhood Spotlights
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            Discover the vibrant communities surrounding our residences, from 
            bustling cultural hubs to serene urban escapes.
          </p>
        </div>

        {}
        <div ref={section1Reveal.ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center transition-all duration-1000 delay-200 ${section1Reveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="relative h-[400px] lg:h-[500px] rounded-md overflow-hidden shadow-xl">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686159/img/urban_cafe_culture.png" alt="Local cafe and street life" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-background/90 to-transparent pointer-events-none" />
          </div>

          <Card className="border-none bg-card shadow-md h-full flex flex-col justify-center p-2 lg:p-6">
            <CardHeader>
              <div className="w-12 h-12 rounded-md bg-primary/10 flex items-center justify-center mb-4 text-primary">
                <Music className="w-6 h-6" />
              </div>
              <CardTitle className="text-2xl md:text-3xl font-default text-foreground">
                The Arts District
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <CardDescription className="text-base md:text-lg text-muted-foreground font-default leading-relaxed">
                Experience a Walkability Score of 98 in the heart of the city. 
                Home to independent galleries, boutique coffee roasters, and 
                live jazz venues, this neighborhood offers an unparalleled 
                urban lifestyle for the modern creative professional.
              </CardDescription>
              <Button variant="outline" className="group border-primary/50 hover:bg-primary hover:text-primary-foreground rounded-md">
                Explore Residences
                <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
              </Button>
            </CardContent>
          </Card>
        </div>

        {}
        <div ref={section2Reveal.ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center transition-all duration-1000 delay-300 ${section2Reveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <Card className="border-none bg-card shadow-md h-full flex flex-col justify-center p-2 lg:p-6 order-2 lg:order-1">
            <CardHeader>
              <div className="w-12 h-12 rounded-md bg-primary/10 flex items-center justify-center mb-4 text-primary">
                <Utensils className="w-6 h-6" />
              </div>
              <CardTitle className="text-2xl md:text-3xl font-default text-foreground">
                Riverside Commons
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <CardDescription className="text-base md:text-lg text-muted-foreground font-default leading-relaxed">
                Boasting a Transit Score of 92, Riverside Commons blends 
                natural beauty with seamless connectivity. Enjoy waterfront 
                jogging paths and premium dining, all within minutes of the 
                central business district via the express metro line.
              </CardDescription>
              <Button variant="outline" className="group border-primary/50 hover:bg-primary hover:text-primary-foreground rounded-md">
                View Local Listings
                <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
              </Button>
            </CardContent>
          </Card>

          <div className="relative h-[400px] lg:h-[500px] rounded-md overflow-hidden shadow-xl order-1 lg:order-2">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686159/img/riverside_park_view.png" alt="Riverside park and transit hub" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-background/90 to-transparent pointer-events-none" />
          </div>
        </div>
      </div>
    </section>;
}